import React from "react";

interface ActionButtonProps {
    label: string;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    icon?: React.ReactNode;
    type?: "button" | "submit" | "reset";
    ariaLabel?: string;
    className?: string;
    style?: React.CSSProperties;
}

const ActionButton: React.FC<ActionButtonProps> = ({ label, onClick, icon, type = "button", ariaLabel, className, style }) => {
    return (
        <button
            type={type}
            aria-label={ariaLabel ?? label}
            className={`actionButton ${className ?? ""}`}
            onClick={onClick}
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 8,
                fontSize: '0.85rem',
                fontWeight: 500,
                cursor: 'pointer',
                lineHeight: 1,
                ...style,
            }}
        >
            {icon && icon}
            {label}
        </button>
    );
};

export default ActionButton;
